import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { fetchInboxActionTypes } from '../constants/unifiedInboxActionTypes';
import { fetchInboxesClient } from '../clients/fetchInboxesClient';
export const fetchInboxes = createAsyncAction({
  requestFn: fetchInboxesClient,
  actionTypes: fetchInboxActionTypes,
  toRecordFn: response => response
});